// extracted by mini-css-extract-plugin
module.exports = {"container":"Query_container__3ht9C","glMaxWidth":"Query_glMaxWidth__3htE5"};